import script from "./VacationAccordion.vue?vue&type=script&setup=true&lang=ts"
export * from "./VacationAccordion.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__